// extracted by mini-css-extract-plugin
export default {"wrapper":"BC","content":"CC","firstSection":"EC","text":"FC","table":"GC","tableText":"HC","row":"IC","column_2":"JC","column_1":"KC","column_3":"LC"};
    if(module.hot) {
      // 1715276856587
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  